<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="disableSubmit"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <empzone-col-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></empzone-col-form>
  </j-modal>
</template>

<script>

  import EmpzoneColForm from './EmpzoneColForm'
  export default {
    name: 'EmpzoneColModal',
    components: {
      EmpzoneColForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      addChildren (parentId,siteId,siteCode) {
        this.disableSubmit = false
        this.title = '新增子欄目'
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.addChildren(parentId,siteId,siteCode);
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>